module.exports = __webpack_public_path__ + "img/intro-sp-katsuyou.a247fe8a.jpg";